<template>
  <div
    class="item"
    :class="{
      pointer:
        setting.type === 'SHARE' ||
        setting.action === 'create' ||
        setting.action === 'participant-add',
    }"
    @click="onClick"
  >
    <ChatAvatar
      :src="formatItemData.photo"
      :text="formatItemData.name"
      class="item__img unselectable"
      :online="itemData.participantData && itemData.participantData.user.wasOnlineAt === 'online'"
    />
    <div class="item__info">
      <div class="item__info__title f14 fw400">
        <svg
          v-if="participantIsAdmin && setting.action !== 'create'"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.5 11.2516L12.135 14L10.905 8.82L15 5.33474L9.6075 4.88526L7.5 0L5.3925 4.88526L0 5.33474L4.095 8.82L2.865 14L7.5 11.2516Z"
            fill="#277FAF"
          />
        </svg>
        {{ formatItemData.name }}
      </div>
      <div class="item__info__type f12 fw400">
        {{ formatItemData.info }}
      </div>
      <div v-if="formatItemData.online" class="f13 mt-2">
        {{ formatItemData.online }}
      </div>
    </div>
    <v-checkbox
      v-if="
        severalRecipients ||
        (setting.type === 'GROUP' &&
          (setting.action === 'create' || setting.action === 'participant-add'))
      "
      :input-value="value.includes(itemData.id)"
      @change="checkboxChange"
      class="checkbox p-2"
    ></v-checkbox>
    <button
      v-if="setting.action === 'participant-remove' && !participantIsAdmin"
      class="cross"
      @click="onRemoveParticipant"
    >
      <BaseIcon color="#B4B4B4" icon="button-cross" />
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ChatAvatar from 'components/chat/ChatAvatar'
export default {
  name: 'ChatModalListItem',
  components: { ChatAvatar },
  data: () => ({}),
  props: {
    itemData: Object,
    setting: Object,
    chats: Array,
    chatSelect: Object,
    selectUser: Array,
    value: {
      type: Array,
      default: () => [],
    },
    severalRecipients: Boolean,
    chatTranslations: Object,
  },
  computed: {
    ...mapState(['apiDomain', 'chatApiDomain']),
    ...mapGetters('user', ['userData']),
    ...mapState('chat', ['chatsList']),
    participantIsAdmin() {
      return (
        this.currentItemIsUser &&
        this.itemData.participantData &&
        this.itemData.participantData.isAdmin
      )
    },
    currentItemIsUser() {
      return this.itemData.messages ? false : true
    },
    formatItemData() {
      return {
        name: this.currentItemIsUser
          ? this.itemData.first_name + ' ' + this.itemData.last_name
          : this.itemData.displayData.name,
        photo: this.currentItemIsUser ? this.itemData.photo : this.itemData.displayData.photo,
        info: this.currentItemIsUser
          ? this.itemData.work_role ||
            this.localStorage.translations.pages.personnel_department.employees_card[
              'dolzhnost-ne-naznachena'
            ]
          : this.itemData.displayData.info,
        online:
          this.currentItemIsUser && this.itemData.participantData
            ? this.itemData.participantData.user.wasOnlineAt === 'online'
              ? this.chatTranslations.online
              : this.localStorage.translations.pages['setting-users'].tables['visit'] +
                ' - ' +
                this.$dayjs(this.itemData.participantData.user.wasOnlineAt).fromNow()
            : null,
      }
    },
  },
  methods: {
    ...mapActions('chat', ['DELETE_chatGroupParticipant']),
    ...mapActions('chat/messages', ['FORWARD_chatMessages']),
    ...mapMutations('chat', ['SET_pushChatInList']),
    checkboxChange(value) {
      if (value) {
        if (!this.value.includes(this.itemData.id)) {
          this.$set(this.value, this.value.length, this.itemData.id)
        }
      } else {
        const findIndex = this.value.indexOf(this.itemData.id)
        if (findIndex > -1) {
          this.$delete(this.value, findIndex)
        }
      }
    },
    onClick(v) {
      if (this.setting.type === 'PERSONAL') {
        if (this.setting.action === 'create' && !this.severalRecipients) {
          const plugСhatId = 'personal_' + this.itemData.id
          const findCreatededChat = this.chats.find(
            (i) =>
              i.type === 'PERSONAL' &&
              i.id !== plugСhatId &&
              !!i.participants.find((i) => i.userId === this.itemData.id),
          )
          if (findCreatededChat) {
            if (this.$route.params.id !== findCreatededChat.id) {
              this.$router.push({ name: 'chatById', params: { id: findCreatededChat.id } })
            }
          } else if (!!this.chats.find((i) => i.id === plugСhatId)) {
            if (this.$route.params.id !== plugСhatId) {
              this.$router.push({ name: 'chatById', params: { id: plugСhatId } })
            }
          } else {
            let data = {
              id: plugСhatId,
              isPlug: true,
              type: 'PERSONAL',
              title: null,
              description: null,
              createdById: this.userData.id,
              createdAt: new Date().toString(),
              isDeleted: false,
              messages: [],
              participants: [
                {
                  userId: this.itemData.id,
                  chatId: plugСhatId,
                  isAdmin: false,
                  isNotificationsEnabled: true,
                  isHistoryAvailable: true,
                  joinedAt: new Date().toString(),
                  leftAt: null,
                },
                {
                  userId: this.userData.id,
                  chatId: plugСhatId,
                  isAdmin: false,
                  isNotificationsEnabled: true,
                  isHistoryAvailable: true,
                  joinedAt: new Date().toString(),
                  leftAt: null,
                },
              ],
              _count: {
                messages: 0,
              },
            }
            if (!this.chatsList.find((i) => i.id === plugСhatId)) {
              this.SET_pushChatInList(data)
            }
            this.$router.push({ name: 'chatById', params: { id: plugСhatId } })
          }
          this.$emit('closeModal')
        }
      } else if (this.setting.type === 'SHARE') {
        this.FORWARD_chatMessages({
          chatId: this.itemData.id,
          messageIds: this.setting.messagesId,
        }).then(() => {
          this.$router.push({ name: 'chatById', params: { id: this.itemData.id } })
          this.$emit('closeModal')
        })
      }
    },
    onRemoveParticipant() {
      let data = {
        userIds: [this.itemData.id],
        chatId: this.chatSelect.id,
        isHistoryAvailable: true,
      }
      this.DELETE_chatGroupParticipant(data)
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  padding: 8px 16px;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  gap: 16px;
  position: relative;
  transition: 0.3s;
  &__img {
    align-self: center;
  }
  &__info {
    align-self: center;
    &__title {
      color: var(--v-secondary-darken2);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__type {
      color: var(--v-primary-lighten2);
      margin-top: 4px;
    }
  }
  :deep() .checkbox {
    margin-top: 0px;
    padding-top: 0px;
    .v-input__slot {
      min-height: 50px !important;
      margin-bottom: 0 !important;
    }
    .v-messages {
      display: none;
    }
  }

  &:hover {
    background: var(--v-secondary-lighten2);
  }
  :deep() .cross {
    width: 50px;
    &:hover {
      svg {
        path {
          stroke: var(--v-error-base);
        }
      }
    }
  }
}
</style>
